import { useState, useRef, useMemo, useCallback } from 'react';
import cookieParser from 'cookie-universal';
import { StorageContext } from './storage-context';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import config from '../../config'

globalThis.cookieInstance = typeof window === 'undefined' ? false : cookieParser();

const cookieTimeout = config.cookieExpireTime ?? (60 * 60 * 24 * 30 * 2) // 2 Months;
const cookieExpireDate = (new Date(Date.now() + cookieTimeout*1000));

(() => {
	var now = new Date();
	var time = now.getTime();
	var expireTime = time + 1000*36000;
	now.setTime(expireTime);
	return now.toUTCString();
})();

const parseCookies = (ssrCookies) => {
	return typeof window === 'undefined' ? ssrCookies :
		{
			...config.defaultStorageValues,
			...pick(globalThis.cookieInstance.getAll(), Object.keys(config.defaultStorageValues)),
		};
}

export const StorageProvider = ({ children, initialCookies }) => {
	const storageDataRef = useRef(parseCookies(initialCookies))
	const [storageData, setStorageDataRaw] = useState(storageDataRef.current);

	const setStorageData = (newData) => {
		storageDataRef.current = newData;
		setStorageDataRaw(storageDataRef.current);
	}

	const setData = useCallback((key, value) => {
		if(globalThis.cookieInstance) {
			if(value) {
				globalThis.cookieInstance.set(key, value, {
					domain: config.cookieDomain,
					sameSite: true,
					secure: true,
					path: '/',
					expires: cookieExpireDate,
					maxAge: cookieTimeout,
					...(config.cookieConfig?.[key] ?? {}),
				});
				setStorageData({ ...storageDataRef.current, [key]: value });
			}
			else {
				globalThis.cookieInstance.remove(key, {
					domain: config.cookieDomain,
					sameSite: true,
					secure: true,
					path: '/',
					... config.cookieConfig?.[key] ?? {}
				});
				setStorageData(omit(storageDataRef.current, [key]));
			}
		}
	}, []);

	const api = useMemo(() => ({
		...storageData,
		setData,
	}), [storageData])

	return (
		<StorageContext.Provider value={api}>
			{children}
		</StorageContext.Provider>
	)
}

StorageProvider.propTypes = {
	children: PropTypes.node,
	initialCookies: PropTypes.object,
}